export default __webpack_public_path__ + "static/media/extended.5947fed3.jpg";